/* eslint-disable no-restricted-imports */
import { Popup } from '@workday/canvas-kit-react';
import { StyledType, createComponent } from '@workday/canvas-kit-react/common';
import { PopupCloseIconProps } from '@workday/canvas-kit-react/dist/es6/popup/lib/PopupCloseIcon';
import { Modal } from '@workday/canvas-kit-react/modal';
import { WcpCard, tertiaryButtonColors } from '@workday/wcp-cargo-react';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { Ref } from 'react';
import { ThemedTertiaryButton } from './ThemedTertiaryButton';

const ThemedPopupHeading: React.FC<React.ComponentProps<typeof Popup.Heading>> = (props) => {
  return <Popup.Heading {...props} color={WcpStyles.color.text.default} />;
};

export const ThemedPopupCloseIcon = createComponent(ThemedTertiaryButton)({
  Component: (props: PopupCloseIconProps & StyledType, ref: Ref<HTMLButtonElement>, Element) => (
    <Modal.CloseIcon ref={ref} as={Element} colors={tertiaryButtonColors(props)} {...props} />
  ),
});

export const ThemedPopup = (props: React.ComponentProps<typeof Popup>) => <Popup {...props} />;
ThemedPopup.Card = WcpCard;
ThemedPopup.Target = Popup.Target;
ThemedPopup.Body = Popup.Body;
ThemedPopup.CloseButton = Popup.CloseButton;
ThemedPopup.CloseIcon = ThemedPopupCloseIcon;
ThemedPopup.Popper = Popup.Popper;
ThemedPopup.Heading = ThemedPopupHeading;
